var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardSearchNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#212325"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0416 29.2497C25.8511 29.2497 29.75 25.3508 29.75 20.5413C29.75 15.7319 25.8511 11.833 21.0416 11.833C16.2322 11.833 12.3333 15.7319 12.3333 20.5413C12.3333 25.3508 16.2322 29.2497 21.0416 29.2497Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6666 30.1663L28.8333 28.333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSearchNormal);
export default __webpack_public_path__ + "static/media/dashboard-search-normal.f3724323a2065744c1359d23c587e423.svg";
export { ForwardRef as ReactComponent };